// Custom Product Info Card JavaScript

document.addEventListener('DOMContentLoaded', function() {
  
  // Function to calculate optimal position for product card based on quadrant
  function calculateOptimalPosition(productContainer) {
    const productCard = productContainer.querySelector('.position-product-card');
    const containerRect = productContainer.getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    
    // Remove all position classes
    productCard.classList.remove(
      'position-product-card--top',
      'position-product-card--bottom',
      'position-product-card--left',
      'position-product-card--right',
      'position-product-card--top-left',
      'position-product-card--top-right',
      'position-product-card--bottom-left',
      'position-product-card--bottom-right',
      'position-product-card--mobile-center'
    );
    
    // Check if mobile screen (≤768px)
    if (viewportWidth <= 768) {
      // On mobile, center horizontally but position above/below based on dot position
      const viewportCenterY = viewportHeight / 2;
      const dotCenterY = containerRect.top + (containerRect.height / 2);
      
      // Get the left position from the product container
      const containerLeft = parseFloat(productContainer.style.left) || 0;
      
      if (dotCenterY > viewportCenterY) {
        // Dot is in bottom half, show card above
        productCard.classList.add('position-product-card--mobile-center-above');
        productCard.style.transform = `translateX(${-containerLeft}%)`;
        productCard.style.marginBottom = '30px';
        productCard.style.marginTop = '0';
      } else {
        // Dot is in top half, show card below
        productCard.classList.add('position-product-card--mobile-center-below');
        productCard.style.transform = `translateX(${-containerLeft}%)`;
        productCard.style.marginTop = '30px';
        productCard.style.marginBottom = '0';
      }
      return;
    }
    
    // Desktop positioning logic
    const viewportCenterX = viewportWidth / 2;
    const viewportCenterY = viewportHeight / 2;
    
    // Calculate center point of the dot
    const dotCenterX = containerRect.left + (containerRect.width / 2);
    const dotCenterY = containerRect.top + (containerRect.height / 2);
    
    // Determine which quadrant the dot is in
    const isRightSide = dotCenterX > viewportCenterX;
    const isBottomHalf = dotCenterY > viewportCenterY;
    
    // Apply position based on quadrant
    let positionClass = '';
    
    if (isRightSide && isBottomHalf) {
      // Bottom-right quadrant: open to top-left
      positionClass = 'position-product-card--top-left';
    } else if (isRightSide && !isBottomHalf) {
      // Top-right quadrant: open to bottom-left
      positionClass = 'position-product-card--bottom-left';
    } else if (!isRightSide && isBottomHalf) {
      // Bottom-left quadrant: open to top-right
      positionClass = 'position-product-card--top-right';
    } else {
      // Top-left quadrant: open to bottom-right
      positionClass = 'position-product-card--bottom-right';
    }
    
    productCard.classList.add(positionClass);
  }

  // Function to update button states
  function updateQuantityButtonStates(quantityInput) {
    const currentValue = parseInt(quantityInput.value) || 1;
    const maxValue = parseInt(quantityInput.getAttribute('max')) || 999;
    const minValue = parseInt(quantityInput.getAttribute('min')) || 1;
    
    const decreaseBtn = quantityInput.parentElement.querySelector('[data-action="decrease"]');
    const increaseBtn = quantityInput.parentElement.querySelector('[data-action="increase"]');
    
    
    // Disable/enable decrease button
    if (decreaseBtn) {
      if (currentValue <= minValue) {
        decreaseBtn.disabled = true;
        decreaseBtn.classList.add('disabled');
      } else {
        decreaseBtn.disabled = false;
        decreaseBtn.classList.remove('disabled');
      }
    }
    
    // Disable/enable increase button
    if (increaseBtn) {
      if (currentValue >= maxValue) {
        increaseBtn.disabled = true;
        increaseBtn.classList.add('disabled');
      } else {
        increaseBtn.disabled = false;
        increaseBtn.classList.remove('disabled');
      }
    }
  }

  // Handle quantity buttons
  document.addEventListener('click', function(e) {
    if (e.target.closest('.custom-product-info__quantity-btn')) {
      const button = e.target.closest('.custom-product-info__quantity-btn');
      const action = button.getAttribute('data-action');
      const quantityInput = button.parentElement.querySelector('.custom-product-info__quantity-input');
      let currentValue = parseInt(quantityInput.value) || 1;
      const maxValue = parseInt(quantityInput.getAttribute('max')) || 999;
      const minValue = parseInt(quantityInput.getAttribute('min')) || 1;
      
      if (action === 'increase' && currentValue < maxValue) {
        quantityInput.value = currentValue + 1;
        updateQuantityButtonStates(quantityInput);
      } else if (action === 'decrease' && currentValue > minValue) {
        quantityInput.value = currentValue - 1;
        updateQuantityButtonStates(quantityInput);
      }
    }
  });

  // Handle manual input changes
  document.addEventListener('input', function(e) {
    if (e.target.classList.contains('custom-product-info__quantity-input')) {
      updateQuantityButtonStates(e.target);
    }
  });

  // Initialize button states on page load
  function initializeQuantityButtons() {
    document.querySelectorAll('.custom-product-info__quantity-input').forEach(input => {
      updateQuantityButtonStates(input);
    });
  }
  
  // Initialize immediately if DOM is already loaded, otherwise wait for DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeQuantityButtons);
  } else {
    initializeQuantityButtons();
  }

  // Handle close button
  document.addEventListener('click', function(e) {
    if (e.target.closest('.custom-product-info__close')) {
      const productCard = e.target.closest('.position-product-card');
      const productContainer = e.target.closest('.product-container');
      if (productContainer) {
        productContainer.classList.remove('product-container--active');
      }
    }
  });

  // Handle product dot clicks
  document.addEventListener('click', function(e) {
    if (e.target.closest('.product-dot')) {
      e.preventDefault();
      const productContainer = e.target.closest('.product-container');
      
      // Close all other product cards
      document.querySelectorAll('.product-container--active').forEach(container => {
        if (container !== productContainer) {
          container.classList.remove('product-container--active');
        }
      });
      
      // Calculate optimal position before showing
      calculateOptimalPosition(productContainer);
      
      // Toggle current product card
      productContainer.classList.toggle('product-container--active');
    }
  });

  // Close product cards when clicking outside
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.product-container')) {
      document.querySelectorAll('.product-container--active').forEach(container => {
        container.classList.remove('product-container--active');
      });
    }
  });

  // Recalculate positions on window resize
  window.addEventListener('resize', function() {
    document.querySelectorAll('.product-container--active').forEach(container => {
      calculateOptimalPosition(container);
    });
  });

  // Handle form submission
  document.addEventListener('submit', function(e) {
    if (e.target.closest('.custom-product-info__form')) {
      e.preventDefault();
      const form = e.target;
      const formData = new FormData(form);
      
      // Add to cart via AJAX
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        // Show success message or update cart
        // You can add custom cart notification here
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
      });
    }
  });
});